import React from "react";
import { Link } from "react-router-dom";
import MarketPriceCard from "./home/MarketPriceCard";
import classnames from "classnames";
import styles from "./Home.module.scss";
import MoneyBalanceCard from "./home/MoneyBalanceCard";
import MinutesBalanceCard from "./home/MinutesBalanceCard";
import JobsCard from "./home/JobsCard";
import FilesCard from "./home/FilesCard";
import TeamsCard from "./home/TeamsCard";
import AnimationCard from "./home/AnimationCard";

const Home: React.FC = () => {
    return (
        <div className="container">
            <div className="row">
                <h2>Home</h2>
            </div>
            <div className={classnames("row", styles.buttonGroup)}>
                <Link
                    className={classnames(
                        "btn btn-sm btn-outline-secondary",
                        styles.buttonRightMargin
                    )}
                    to="/home/dashboard"
                >
                    Dashboard
                </Link>
                <Link
                    className={classnames(
                        "btn btn-sm btn-outline-secondary",
                        styles.buttonRightMargin
                    )}
                    to="/home/account-setup"
                >
                    Account Setup
                </Link>
                <Link
                    className="btn btn-sm btn-outline-secondary"
                    to="/home/settings"
                >
                    Settings
                </Link>
            </div>
            <div className="row">
                <AnimationCard />
                <JobsCard />
                <TeamsCard />
                <FilesCard />
                <MoneyBalanceCard />
                <MinutesBalanceCard />
                <MarketPriceCard />
            </div>
        </div>
    );
};

export default Home;
